// domain/visita.schema.js  (yup es agnóstico de React; se permite en domain)
import * as yup from 'yup';

export const MAX_MOTIVO_VISITA = 150;

// '' / undefined -> null; el resto se castea a número
const optionalId = yup
  .number()
  .transform((value, original) => (original === '' || original === null || original === undefined ? null : value))
  .nullable();

export const visitaSchema = yup.object().shape({
  motivo: yup
    .string()
    .trim()
    .required('El motivo es requerido')
    .max(MAX_MOTIVO_VISITA, `Máximo ${MAX_MOTIVO_VISITA} caracteres`),
  fecha: yup
    .string()
    .required('La fecha es requerida')
    .matches(/^\d{4}-\d{2}-\d{2}$/, 'Fecha inválida'),
  id_cuenta: optionalId.required('El productor es requerido'),
  id_parcela: optionalId,
  id_ciclo: optionalId,
  observaciones: yup.string().nullable(),
});
